(function(){
  // Reveal all collapsed reviews + hide show-more button (used by filter + show-more)
  function rhExpandAllReviews(){
    document.querySelectorAll('[data-rh-reviews-grid] .rh-collapsed').forEach(function(c){
      c.classList.remove('rh-collapsed');
    });
    document.querySelectorAll('[data-rh-show-more-wrap]').forEach(function(w){
      w.setAttribute('data-rh-hide','1');
    });
  }

  // Filter reviews by rating
  document.querySelectorAll('[data-rh-filter-bar]').forEach(function(bar){
    var grid = document.querySelector('[data-rh-reviews-grid]');
    if (!grid) return;
    var cards = grid.querySelectorAll('[data-rh-review]');
    bar.querySelectorAll('[data-rh-filter]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var f = btn.getAttribute('data-rh-filter');
        bar.querySelectorAll('[data-rh-filter]').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        rhExpandAllReviews();
        cards.forEach(function(c){
          if (f === 'all' || c.getAttribute('data-rating') === f) c.classList.remove('hidden');
          else c.classList.add('hidden');
        });
      });
    });
  });

  // Show more reviews
  document.querySelectorAll('[data-rh-show-more]').forEach(function(btn){
    btn.addEventListener('click', function(){ rhExpandAllReviews(); });
  });

  // FAQ accordion
  document.querySelectorAll('[data-rh-faq-item]').forEach(function(item){
    var q = item.querySelector('[data-rh-faq-q]');
    if (!q) return;
    q.addEventListener('click', function(){
      var open = item.classList.contains('open');
      item.parentNode.querySelectorAll('[data-rh-faq-item]').forEach(function(x){ x.classList.remove('open'); });
      if (!open) item.classList.add('open');
    });
  });

  // Smooth scroll for in-page anchors
  document.querySelectorAll('[data-rh-scroll]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('data-rh-scroll');
      var target = document.getElementById(id);
      if (target){
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({top:y, behavior:'smooth'});
      }
    });
  });

  // Scroll-dependent chrome (header.scrolled, anchor-nav.visible, sticky-bottom.visible)
  var header = document.querySelector('[data-rh-header]');
  var anchorNav = document.querySelector('[data-rh-anchor-nav]');
  var stickyBottom = document.querySelector('[data-rh-sticky-bottom]');
  if (header || anchorNav || stickyBottom){
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      if (header) header.classList.toggle('scrolled', y > 40);
      if (anchorNav) anchorNav.classList.toggle('visible', y > 400);
      if (stickyBottom) stickyBottom.classList.toggle('visible', y > 400);
    }, {passive:true});
  }

  // Active anchor highlight via IntersectionObserver
  var anchorLinks = document.querySelectorAll('[data-rh-anchor]');
  if (anchorLinks.length && 'IntersectionObserver' in window){
    var sections = [];
    anchorLinks.forEach(function(a){
      var id = a.getAttribute('data-rh-anchor');
      var s = document.getElementById(id);
      if (s) sections.push(s);
    });
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          anchorLinks.forEach(function(a){
            a.classList.toggle('active', a.getAttribute('data-rh-anchor') === entry.target.id);
          });
        }
      });
    }, {rootMargin:'-120px 0px -60% 0px', threshold:0});
    sections.forEach(function(s){ observer.observe(s); });
  }
})();
